





































import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
import { init } from './js/js';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    mounted() {
        init()
    }
    updateYzm(){
        this.current.updateYzm()
    }
    login () {
        utils.my_post({apiName:"login",isEncryption:true,
            params: {
                ui_code:this.current.usercode,
                ui_password:this.current.password,
                isCookie:this.current.isCookie,
                yzm:this.current.yzm,
                type:"pc"
            },
            ok: (json:any, dataAll:any) => {
                this.current.usercode=""
                this.current.password=""
                utils.login({user: json})
            },err:(json:any, dataAll:any) => {
                if(dataAll.message != "验证码错误"){
                    this.current.updateYzm()
                }
            }})
    }
}

